import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useBulkPersonalOrderOrdererDetailStore = defineStore(
  'bulkPersonalOrderOrdererDetail',
  () => {
    const lastName = ref('')
    const firstName = ref('')
    const email = ref('')
    const emailConfirm = ref('')
    const zipcode = ref('')
    const prefectureId = ref(0)
    const address1 = ref('')
    const address2 = ref('')
    const phoneNumber = ref('')
    const payerFullNameKana = ref('')
    const purposeOfUse = ref('')
    const note = ref('')

    const $reset = () => {
      lastName.value = ''
      firstName.value = ''
      email.value = ''
      emailConfirm.value = ''
      zipcode.value = ''
      prefectureId.value = 0
      address1.value = ''
      address2.value = ''
      phoneNumber.value = ''
      payerFullNameKana.value = ''
      purposeOfUse.value = ''
      note.value = ''
    }

    const setLastName = value => (lastName.value = value)
    const setFirstName = value => (firstName.value = value)
    const setEmail = value => (email.value = value)
    const setEmailConfirm = value => (emailConfirm.value = value)
    const setZipcode = value => (zipcode.value = value)
    const setPrefectureId = value => (prefectureId.value = value)
    const setAddress1 = value => (address1.value = value)
    const setAddress2 = value => (address2.value = value)
    const setPhoneNumber = value => (phoneNumber.value = value)
    const setPayerFullNameKana = value => (payerFullNameKana.value = value)
    const setPurposeOfUse = value => (purposeOfUse.value = value)
    const setNote = value => (note.value = value)

    return {
      lastName,
      firstName,
      email,
      emailConfirm,
      zipcode,
      prefectureId,
      address1,
      address2,
      phoneNumber,
      payerFullNameKana,
      purposeOfUse,
      note,
      $reset,
      setLastName,
      setFirstName,
      setEmail,
      setEmailConfirm,
      setZipcode,
      setPrefectureId,
      setAddress1,
      setAddress2,
      setPhoneNumber,
      setPayerFullNameKana,
      setPurposeOfUse,
      setNote
    }
  },
  {
    persist: true
  }
)
